export default "__VITE_ASSET__4f0595ef__"